import store from "../store/index"
import { axiosApi, uploadApi } from "./api"
import { dayEnd, dayStart, yearStart, yearEnd, monthStart, monthEnd } from '../util/DateUtil'
import Axios from "axios"

//项目下用户列表
export const userList= (data) => axiosApi('get', '/v3/center/firm/user/list')(data);

//允许-取消访问
export const userAccess= (data) => axiosApi('post', '/v3/center/firm/user/access')(data);

//重置密码
export const userUpdatedepsw= (data) => axiosApi('put', '/user/updatedefaultpsw')(data);

//删除用户信息
export const userDelete= (data) => axiosApi('delete', '/user/delete')(data);

//修改用户信息
export const userUpdate= (data) => axiosApi('put', '/v3/center/user/update/info',true)(data);

//修改企业信息
export const projectUpdate= (data) => axiosApi('post', '/project/update')(data);

//新增用户信息
export const userAdd= (data) => axiosApi('put', '/v3/center/user/add',true)(data);

//修改企业信息
export const updateProjectAndFirm= (data) => axiosApi('post', '/v3/center/updateProjectAndFirm',true)(data);
